import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";

import { useTranslate } from "@/composables";
import { EXPERIMENTS_TRENDING_POST_CAROUSEL } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopPostsTab',
  props: {
  ltkIds: { type: Array as () => string[], required: true },
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isSearch: { type: Boolean, required: true },
  isVisible: { type: Boolean, default: false },
  showLoading: { type: Boolean, required: true },
  showError: { type: Boolean, required: true },
},
  emits: ["page", "retry"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "page"): void;
  (e: "retry"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { t } = useTranslate();

const trendingPostCarouselExperiment = computed(() => EXPERIMENTS_TRENDING_POST_CAROUSEL);
const postFeedTitle = computed(() => {
  if (props.isSearch) {
    return t("Matching posts").value;
  }
  return t("Recent posts").value;
});

const onRetry = () => {
  emits("retry");
};

const onPage = () => {
  emits("page");
};

return { __sfc: true,props, emits, t, trendingPostCarouselExperiment, postFeedTitle, onRetry, onPage }
}

})